export default "__VITE_ASSET__DSHnE9C7__"